var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDeletebox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.092v-2h10v2h5v2h-2v15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-15H2v-2h5zm-1 2v14h12v-14H6zm3 3h2v8H9v-8zm4 0h2v8h-2v-8z",
    fill: "#DB233A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeletebox);
export default __webpack_public_path__ + "static/media/ic-deletebox.2efec021923fe0340c5b22ffa156ba71.svg";
export { ForwardRef as ReactComponent };